import React, { useEffect } from "react";
// import PropTypes from "prop-types";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { CourseCard, Explorer, Filters, Paginator } from "@components";
import { getAllMyLearningAction } from "@redux/modules/course/slices";
import styles from "./styles/MyLearningPage.module.css";
import clsx from "clsx";
import { useState } from "react";
import { useWindowSize } from "@hooks";
import { formatNumberText, searchParamsToObject } from "@helpers";
import { useSearchParams } from "react-router-dom";
import { DEFAULT_PAGE_SIZE } from "@constants";

const sortOptions = [
  {
    id: "timeGoDown",
    label: "Newest First",
    value: "createdAt desc",
  },
  {
    id: "ratingGoUp",
    label: "Highest Rating First",
    value: "avgRate desc",
  },
];

const defaultFilters = {
  CategoryId: [],
  LevelIds: [],
  AudioLanguageIds: [],
  IsFree: false,
  IsDiscount: false,
  Rate: -1,
  MinPrice: 0,
  MaxPrice: 1000,
};

const MyLearningPage = () => {
  // state
  const [filterVisible, setFilterVisible] = useState(false);

  // variables
  let pagination = null;
  let resultSummary = "";

  // logics before hooks

  // hooks
  const { width } = useWindowSize();
  const [searchParams] = useSearchParams();
  const { submitReviewCourse, updateReviewCourse } = useSelector(
    (state) => state.review
  );
  const { getAllMyLearning } = useSelector((state) => state.course);
  const dispatch = useDispatch();

  // logics
  if (getAllMyLearning.pagination) {
    pagination = <Paginator data={{ ...getAllMyLearning.pagination }} />;
    const { CurrentPage, PageSize, TotalCount } = getAllMyLearning.pagination;
    const start = (CurrentPage - 1) * PageSize + 1;
    const end = CurrentPage * PageSize;
    resultSummary = TotalCount
      ? `Showing ${start} to ${
          end < TotalCount ? end : TotalCount
        } of total ${formatNumberText(TotalCount, "result")}`
      : "No result";
  }

  const toggleFilterUI = () => setFilterVisible(!filterVisible);

  const hideFilterUI = () => width < 992 && setFilterVisible(false);

  // UI partials

  // effects
  useEffect(() => {
    const Keyword = (searchParams.get("Keyword") || "")
      .replace(/\s+/g, " ")
      .trim();
    const Orderby = searchParams.get("Orderby") || sortOptions[0].value;
    const PageSize = Number(searchParams.get("PageSize")) || DEFAULT_PAGE_SIZE;
    const PageNumber = Number(searchParams.get("PageNumber")) || 1;
    const [currentFilters] = searchParamsToObject(searchParams, defaultFilters);

    dispatch(
      getAllMyLearningAction({
        ...currentFilters,
        Keyword,
        Orderby,
        PageSize,
        PageNumber,
        status: 1,
      })
    );
  }, [submitReviewCourse, updateReviewCourse, searchParams]);

  // render
  return (
    <Container className="position-relative">
      <h3 className="my-4">My Learning</h3>
      <Explorer
        toggleFilterUI={toggleFilterUI}
        ExtendSortOptions={sortOptions}
        ExtendResultSummary={
          getAllMyLearning.processing ? (
            <>
              <Spinner animation="border" size="sm" variant="danger" />
              <span className="ml-2">Searching...</span>
            </>
          ) : (
            <strong>{resultSummary}</strong>
          )
        }
      />
      <div className={styles.content}>
        <div
          className={clsx(
            styles.filterContainer,
            filterVisible ? styles.filterVisible : ""
          )}
        >
          <div
            className={clsx(
              styles.filter,
              filterVisible ? styles.filterVisible : ""
            )}
          >
            <div className={styles.filterMask} onMouseDown={hideFilterUI}></div>
            <div className={clsx(styles.filterContent, "border")}>
              <Filters hideFilterUI={hideFilterUI} />
            </div>
          </div>
        </div>
        <div className={styles.resultContainer}>
          <Row className="gy-4">
            {getAllMyLearning.data?.map((course, index) => {
              return (
                <Col
                  sm={6}
                  xs={12}
                  lg={filterVisible ? 6 : 4}
                  xl={filterVisible ? 4 : 3}
                  key={index}
                >
                  <CourseCard data={course} type={"learn"} />
                </Col>
              );
            })}
            <div className="d-flex justify-content-center">{pagination}</div>
          </Row>
        </div>
      </div>
    </Container>
  );
};

/* required: display name */
MyLearningPage.displayName = "MyLearningPage";

/* required: props types */
MyLearningPage.propTypes = {};

/* required: default props */
MyLearningPage.defaultProps = {};

export { MyLearningPage };
